/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const ReplaceIcon = createIcon(
  '0 0 20 20',
  <path d="M8 13h9v2H8v3l-6-4 6-4zm10-7-6 4V7H3V5h9V2z" />,
);
